import { useBranding } from "../../../contexts/branding";

export default function PoweredByButton() {
    const { label } = useBranding();

    if (label === "HabitNu") {
        // eslint-disable-next-line react/jsx-no-useless-fragment
        return <></>;
    }

    return (
        <div className="row justify-content-center mt-4 mb-4">
            <img
                src="/images/powered-by-habitnu.png"
                alt="Powered by HabitNu"
                className="habitnu-log-powered-by"
            />
        </div>
    );
}
